export default __webpack_public_path__ + "static/media/logo_transparent_background.85178089.png";